module.exports = __webpack_public_path__ + "img/sky-porch-2.f043eb5c.jpg";